export default __webpack_public_path__ + "static/NeueMontreal-Regular-cf544aa8cefb19191923c36128f15d85.woff";